export default {
  'track-Bestaande-Relatie-Via-Extern': {
    name: 'Bestaande relatie koppelen via extern(Bv RIT of Relatiescherm)',
    isEnabled: true,
  },
  'track-Nieuwe-Relatie-Via-Offerte': {
    name: 'Nieuwe relatie koppelen via offerte',
    isEnabled: true,
  },
  'track-Bestaande-Relatie-Via-Offerte': {
    name: 'Bestaande relatie koppelen via offerte',
    isEnabled: true,
  },
  'track-Relatie-Gekoppeld-Aan-Offerte': {
    name: 'Relatie gekoppeld koppelen aan offerte',
    isEnabled: true,
  },
  'track-sbi-details-geopend': {
    name: 'Gebruiker opent de details voor de gekozen sbi-code',
    isEnabled: true,
  },
  'track-inkomens-knop-click': {
    name: 'Gebruiker klikt op de inkomensknop',
    isEnabled: true,
  },
};
